import { useSelector } from "react-redux";

export const useHasConnections = () => {
    const connectionData = useSelector((state) => state.connectionData?.data);
    return Array.isArray(connectionData) && connectionData.length > 0;
};